import * as React from 'react';
import { find as _find } from 'lodash';
import { Modal } from 'reactstrap';
import { setTimeout } from 'timers';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './TermsModal.messages';
import { GlobalPrivateState, getCountryNameByCode } from 'src/api';
import { connect } from 'react-redux';
import { createApiUrl, appSettings } from 'src/config';
import { requestAPIActions } from 'loopback-react-request';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, DropdownItem, DropdownToggle } from 'reactstrap';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';
import { getValueFromPricings, getMarketByCountryCode, PricingsModel } from 'franke-trough-dependencies';
import './TermsModal.scss';
import { Icon } from '../Images';


export interface TermsModalProps {
  dispatch: any;
  // drilledConfirm: (folderName: string) => void;
  drilledClose: () => void;
  pricings: GlobalPrivateState['pricings'];
  selectedMarket?: string;
}

export interface TermsModalState {
  isOpen: boolean; 
  selectedMarket: string; 
	isDropDownOpen: boolean;
}

export class TermsModalPartial extends React.Component<TermsModalProps, TermsModalState> {
  constructor(props: TermsModalProps) {
    super(props);
    this.state = {
      isOpen: false,
      selectedMarket: this.props.selectedMarket || '',
			isDropDownOpen: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
    }
  }

  public render() {
    let selectedMarketValues = null;

    if (this.state.selectedMarket) {
      selectedMarketValues = getMarketByCountryCode(this.props.pricings.result, this.state.selectedMarket) as PricingsModel;
    }

    return (
      <Modal 
        isOpen={this.state.isOpen}
				backdrop={true}
				toggle={this.toggleModal}
        className="modal-dialog--small terms-modal"
      >
				<PricingsDispatcher />
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
          <button onClick={this.toggleModal} className="close-btn">
            <FontAwesomeIcon icon={faTimes} />
          </button>
					<div>
						<h3 className="modal-heading">
              <FormattedMessage {...MESSAGES.termsModalHeading} />
            </h3>
						<div className="modal-body">
              <FormattedMessage {...MESSAGES.termsModalMarket} />
							<div className="partial-select-market">
								<Dropdown
									className="dropdown-select" 
									isOpen={this.state.isDropDownOpen} 
									toggle={this.toggleDropdown} 
								>
									<DropdownToggle className="mt-3 dropdown-toggle">
										{this.state.selectedMarket ? getCountryNameByCode(this.state.selectedMarket) : <FormattedMessage {...MESSAGES.termsModalSelect} />}
									</DropdownToggle>
									<DropdownMenu>
										{this.props.pricings && this.props.pricings.result && this.props.pricings.result.map((pricing, index) => {
											const key = `select_market_dropdown_${index}`;
											const countryCode = getValueFromPricings(pricing, 'country');

											if (!countryCode || pricing.deleted || pricing.type !== 'market') return;

											const countryCodeIso = countryCode && countryCode.split('-')[0];
											const countryName = getCountryNameByCode(countryCode);

											return (
												<DropdownItem 
													key={key} 
													onClick={() => this.handleClick(countryCode)}
												>
													{countryName}
												</DropdownItem>
											);
										})}
									</DropdownMenu>
								</Dropdown>
							</div>
            </div>
						{this.state.selectedMarket && (
							<div className="modal-body">
              	<FormattedMessage {...MESSAGES.termsModalLanguage} />
                <div className="partial-select-language">
                  <ul className="list-unstyled">
                    {selectedMarketValues && (
                      <>
                        {selectedMarketValues.termLinks && selectedMarketValues.termLinks ? selectedMarketValues.termLinks.map((termLink) => {
                          return (
                            <li>
                              <a href={termLink.url} target="_blank">
                                <Icon name="chevron-right" size="small" />
                                {termLink.lang}
                              </a>
                            </li>
                          )
                        }) : (
                          <li>
                            <a href="https://kwc-professional.com/en_global/footer-pages/terms-and-conditions" target="_blank">
                              <Icon name="chevron-right" size="small" />
                              EN
                            </a>
                          </li>
                        )}
                      </>
                    )}
                  </ul>
                </div>
							</div>
						)}
					</div>
        </div>
      </Modal>
    );
  }

  private toggleDropdown() {
    this.setState({isDropDownOpen: !this.state.isDropDownOpen});
  }

  private toggleModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.props.drilledClose(), 151);
  }
	
  private handleClick(countryCode: string) {
    this.setState({selectedMarket: countryCode});
  }
}

// export const UserListDeleteModal = connect((state: GlobalPrivateState) => ({
// }))(UserListDeleteModalPartial as any);

export const TermsModal = connect((state: GlobalPrivateState) => ({
  pricings: state.pricings,
}))(TermsModalPartial);

export default TermsModal;